import { render, staticRenderFns } from "./GamePlatformsBar.vue?vue&type=template&id=530c57d6&"
import script from "./GamePlatformsBar.vue?vue&type=script&lang=js&"
export * from "./GamePlatformsBar.vue?vue&type=script&lang=js&"
import style0 from "./GamePlatformsBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530c57d6')) {
      api.createRecord('530c57d6', component.options)
    } else {
      api.reload('530c57d6', component.options)
    }
    module.hot.accept("./GamePlatformsBar.vue?vue&type=template&id=530c57d6&", function () {
      api.rerender('530c57d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/itemSets/GamePlatformsBar.vue"
export default component.exports